<template>
  <section class="mi-inter">
    <div class="overlay"></div>
    <div class="mi-inter-content">
      
      <!-- Logos de la alianza -->
      <div class="logos-alianza">
        <img src="@/assets/Img/Logo_Navar/logo_sin_fondo_recortado.png" alt="Jean Informático" class="logo" />
        <span class="mas">+</span>
        <img src="@/assets/icons/inter.png" alt="Inter" class="logo" />
      </div>

      <!-- Título y descripción -->
      <h2 class="titulo">¿Qué es <span class="resaltado">Mi Inter</span>?</h2>
      <p class="descripcion">
        Con <strong>Jean Informático</strong> en alianza con <strong>Inter</strong>, 
        ahora tienes acceso a <span class="resaltado">Mi Inter</span>, la plataforma digital
        donde puedes gestionar fácilmente tus servicios de Fibra Óptica:
      </p>

      <!-- Beneficios destacados -->
      <div class="beneficios">
        <div class="card">💨 <h3>Velocidad</h3><p>Internet estable y de alta velocidad.</p></div>
        <div class="card">📱 <h3>Gestión</h3><p>Administra tus servicios desde tu celular.</p></div>
        <div class="card">⏳ <h3>Pagos rápidos</h3><p>Factura al instante sin complicaciones.</p></div>
        <div class="card">👨‍💻 <h3>Soporte</h3><p>Atención técnica especializada.</p></div>
      </div>

      <!-- Mini tutorial -->
      <div class="tutorial">
        <h3>🚀 ¿Cómo usar Mi Inter?</h3>
        <ol>
          <li>Regístrate en la plataforma.</li>
          <li>Activa tu cuenta con tu cédula y contrato.</li>
          <li>Gestiona y paga tus servicios en línea.</li>
        </ol>
      </div>

      <!-- Botones de acción -->
      <div class="acciones">
        <a href="https://www.inter.com.ve/" target="_blank" class="btn-mi-inter">
          🌐 Acceder a Mi Inter
        </a>
        <a
          href="https://wa.me/584125696219?text=Hola%20Jean%20Informático,%20quiero%20ayuda%20con%20Mi%20Inter."
          target="_blank"
          class="btn-whatsapp"
        >
          📲 Contactar Soporte
        </a>
      </div>

      <!-- FAQ dinámico -->
      <div class="faq">
        <h3>❓ Preguntas frecuentes</h3>
        <div v-for="(item, index) in faqs" :key="index" class="faq-item">
          <div class="faq-question" @click="toggleFAQ(index)">
            {{ item.question }}
            <span class="icon">{{ item.open ? "−" : "+" }}</span>
          </div>
          <div v-show="item.open" class="faq-answer">
            {{ item.answer }}
          </div>
        </div>
      </div>

    </div>
  </section>
</template>

<script>
export default {
  name: "MiInter",
  data() {
    return {
      faqs: [
        {
          question: "¿Cómo me registro en Mi Inter?",
          answer: "Solo necesitas tu cédula y número de contrato para crear tu cuenta.",
          open: false,
        },
        {
          question: "¿Qué métodos de pago acepta?",
          answer: "Tarjetas de crédito, transferencias y domiciliación bancaria.",
          open: false,
        },
        {
          question: "¿Puedo usar Mi Inter desde el celular?",
          answer: "Sí, Mi Inter funciona en cualquier dispositivo móvil o computadora.",
          open: false,
        },
      ],
    };
  },
  methods: {
    toggleFAQ(index) {
      this.faqs[index].open = !this.faqs[index].open;
    },
  },
};
</script>

<style scoped>
.mi-inter {
  position: relative;
  padding: 5rem 2rem;
  background: url("@/assets/Img/Banners/fibra-optica.jpg") no-repeat center center;
  background-size: cover;
  text-align: center;
  color: #fff;
  overflow: hidden;
}

.overlay {
  position: absolute;
  top: 0; left: 0;
  width: 100%; height: 100%;
  background: rgba(0, 0, 0, 0.65);
  z-index: 0;
}

.mi-inter-content {
  position: relative;
  z-index: 1;
  max-width: 1000px;
  margin: 0 auto;
  animation: fadeIn 1.5s ease-in-out;
}

/* Logos */
.logos-alianza {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  margin-bottom: 2rem;
}

.logo {
  max-height: 60px;
}

.mas {
  font-size: 2rem;
  font-weight: bold;
  color: #00f2ff;
}

/* Título */
.titulo {
  font-size: 2.5rem;
  font-weight: bold;
  margin-bottom: 1.5rem;
}

.resaltado {
  color: #00f2ff;
  text-shadow: 0 0 12px rgba(0, 242, 255, 0.8);
}

.descripcion {
  font-size: 1.2rem;
  margin-bottom: 3rem;
  line-height: 1.6;
}

/* Beneficios */
.beneficios {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 1.5rem;
  margin-bottom: 3rem;
}

.card {
  background: rgba(255, 255, 255, 0.08);
  padding: 1.5rem;
  border-radius: 15px;
  transition: transform 0.3s ease, background 0.3s ease;
}

.card:hover {
  transform: translateY(-5px);
  background: rgba(255, 255, 255, 0.15);
}

.card h3 {
  margin: 0.5rem 0;
  color: #00f2ff;
}

/* Tutorial */
.tutorial {
  margin-bottom: 3rem;
  text-align: left;
  display: inline-block;
}

.tutorial h3 {
  text-align: center;
  margin-bottom: 1rem;
}

.tutorial ol {
  padding-left: 1.2rem;
  font-size: 1.1rem;
  line-height: 1.6;
}

/* Botones */
.acciones {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 1rem;
  margin-bottom: 3rem;
}

.btn-mi-inter {
  background: #00f2ff;
  color: #0a0f2c;
  padding: 1rem 2rem;
  border-radius: 50px;
  font-size: 1.1rem;
  font-weight: bold;
  text-decoration: none;
  transition: transform 0.3s ease, background 0.3s ease;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.4);
}

.btn-mi-inter:hover {
  background: #00d6e0;
  transform: scale(1.08);
}

.btn-whatsapp {
  background: #25d366;
  color: #fff;
  padding: 1rem 2rem;
  border-radius: 50px;
  font-size: 1.1rem;
  font-weight: bold;
  text-decoration: none;
  transition: transform 0.3s ease, background 0.3s ease;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.4);
}

.btn-whatsapp:hover {
  background: #20b954;
  transform: scale(1.08);
}

/* FAQ dinámico */
.faq {
  text-align: left;
  background: rgba(255, 255, 255, 0.08);
  padding: 2rem;
  border-radius: 15px;
  max-width: 800px;
  margin: 0 auto;
}

.faq h3 {
  margin-bottom: 1rem;
  text-align: center;
}

.faq-item {
  margin-bottom: 1rem;
  border-bottom: 1px solid rgba(255,255,255,0.2);
}

.faq-question {
  cursor: pointer;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.8rem 0;
}

.faq-answer {
  padding: 0.5rem 0 0.8rem 0;
  line-height: 1.5;
  color: #ddd;
}

/* Responsive */
@media (max-width: 768px) {
  .titulo {
    font-size: 2rem;
  }

  .descripcion {
    font-size: 1.05rem;
  }

  .card {
    padding: 1rem;
  }
}

@media (max-width: 480px) {
  .titulo {
    font-size: 1.7rem;
  }

  .descripcion {
    font-size: 1rem;
  }

  .btn-mi-inter,
  .btn-whatsapp {
    font-size: 1rem;
    padding: 0.8rem 1.4rem;
  }
}

/* Animación */
@keyframes fadeIn {
  from { opacity: 0; transform: translateY(40px); }
  to { opacity: 1; transform: translateY(0); }
}
</style>
